export const DESKTOP_WIDTH = 730;
